import { CareerPathwayLevel } from "@/components/career-pathway-level"
import AppLayout from "@/layouts/AppLayout"

export default function CareerPathwayAdvanced() {
  return (
    <CareerPathwayLevel
      config={{
        name: "Advanced",
        level: 2,
        subtitle: "1+ a\u00f1os de experiencia equiparable",
        emoji: "\ud83d\udc25",
        color: "blue",
        description:
          "Desarrollador que puede brindar valor y producir en las tareas m\u00e1s comunes de un equipo de desarrollo web (features de complejidad baja y media, resoluci\u00f3n de bugs o problemas sencillos).",
        sections: [
          {
            title: "Autonom\u00eda",
            color: "blue",
            icon: "\ud83d\udc64",
            content:
              "Capaz de a\u00f1adir valor y producir en las tareas m\u00e1s comunes de un equipo de desarrollo (features de complejidad baja y media, resoluci\u00f3n de bugs o problemas sencillos). Se espera que funcionen de manera independiente la mayor\u00eda del tiempo en tareas de dificultad intermedia a baja.",
          },
          {
            title: "Comprensi\u00f3n del Proceso",
            color: "green",
            icon: "\ud83d\udccb",
            content:
              "Entienden todos los pasos del proceso de desarrollo implementado en el equipo, con participaci\u00f3n principalmente en implementaci\u00f3n y testing.",
          },
          {
            title: "Conocimiento Tecnol\u00f3gico",
            color: "yellow",
            icon: "\ud83d\udcbb",
            content:
              "C\u00f3modos con la tecnolog\u00eda, aunque sin entendimiento profundo de muchas de las herramientas utilizadas. Conocimientos limitados de la soluci\u00f3n t\u00e9cnica o arquitectura del proyecto, con conocimiento m\u00e1s profundo de las partes del c\u00f3digo con las que interact\u00faan m\u00e1s frecuentemente.",
          },
          {
            title: "Feedback y Revisi\u00f3n",
            color: "purple",
            icon: "\ud83d\udcac",
            content:
              "Incorporaci\u00f3n de feedback recibido en pull requests aprendiendo constantemente. En algunas ocasiones pueden presentar opiniones contrarias al feedback recibido, interactuando en los mismos pull requests para llegar a acuerdos.",
          },
          {
            title: "Comunicaci\u00f3n",
            color: "blue",
            icon: "\ud83d\udde3\ufe0f",
            content:
              "Participaci\u00f3n en reuniones con el cliente y capacidad para llevar a cabo comunicaciones necesarias para completar tareas b\u00e1sicas del proyecto. Dependencia de otros para interacciones, aclaraciones o negociaciones m\u00e1s intensas o complejas.",
          },
          {
            title: "Herramientas y Desarrollo",
            color: "green",
            icon: "\ud83d\udee0\ufe0f",
            content:
              "Uso adecuado de Git para operaciones habituales con ocasional necesidad de asistencia en casos m\u00e1s avanzados. Velocidad de desarrollo sostenida para features de complejidad y tama\u00f1o intermedio y bajo, con capacidad para realizar CRs y, en algunos casos, aceptar pull requests en casos sencillos y riesgo bajo.",
          },
        ],
        observableBehaviors: [
          "Incorpora todo el feedback que recibe en un pull request, pero puede argumentar con criterio si tiene una opini\u00f3n contraria, y hay un error en el comentario recibido.",
          "Es capaz de comprender y cumplir con los agreements relacionados al dev process.",
          "Maneja Git de forma acorde, pudiendo realizar todas las operaciones habituales sin asistencia. De vez en cuando, requiere ayuda o es alertado sobre posibilidades que brinda la herramienta para casos m\u00e1s avanzados (usualmente, casos de resoluci\u00f3n de conflictos entre ramas o reordenamiento de commits).",
          "Tiene una velocidad de desarrollo sostenida para features de complejidad y tama\u00f1o intermedio y bajo.",
        ],
        evolution: {
          title: "Evoluci\u00f3n hacia Semi Senior",
          items: [
            {
              title: "Autonom\u00eda",
              points: [
                "Desarrolla un nivel de autonom\u00eda que permita asumir m\u00e1s responsabilidades y realizar tareas b\u00e1sicas sin necesidad de asistencia constante.",
                "Resuelve bloqueos personales.",
              ],
            },
            {
              title: "Manejo de Situaciones",
              points: [
                "Aborda de manera constructiva situaciones internas y externas al equipo.",
                "Evita que los conflictos se vuelvan m\u00e1s grandes y contribuye a su resoluci\u00f3n.",
                "Identifica problemas fuera de su conocimiento y busca soluciones acudiendo a la persona adecuada.",
              ],
            },
            {
              title: "Comunicaci\u00f3n con el Cliente",
              points: [
                "Mantiene una comunicaci\u00f3n clara y precisa con el cliente.",
                "Explica de manera efectiva y en ingl\u00e9s los problemas al cliente, realiza demos.",
                "Participaci\u00f3n activa en reuniones, basada en una comprensi\u00f3n clara de los temas discutidos.",
              ],
            },
            {
              title: "Profundizando",
              points: [
                "Con al menos un a\u00f1o de experiencia, se espera que sea capaz de ejecutar tareas de desarrollo de principio a fin para los casos m\u00e1s sencillos.",
                "Contribuye a nivel de equipo. Ya adaptado a las din\u00e1micas de trabajo y desaf\u00edos de su proyecto.",
              ],
            },
          ],
        },
        prev: { name: "Anterior: Junior", url: "/growth/career-pathway/junior" },
        next: { name: "Siguiente: Semi Senior", url: "/growth/career-pathway/semi-senior" },
      }}
    />
  )
}

CareerPathwayAdvanced.layout = (page: React.ReactNode) => <AppLayout>{page}</AppLayout>
